import { Signal } from './Signal';

export class FocusObserver {
  public readonly onBlur: Signal<void> = new Signal();
  public readonly onFocus: Signal<void> = new Signal();

  private focused = false;

  constructor() {
    window.addEventListener('blur', this.handleBlur);
    window.addEventListener('focus', this.handleFocus);
    document.addEventListener('pointerdown', this.handleFocus);
  }

  public isFocused(): boolean {
    return this.focused;
  }

  private handleBlur = () => {
    if (!this.focused) return;
    this.focused = false;
    this.onBlur.dispatch();
  };

  private handleFocus = () => {
    if (this.focused) return;
    this.focused = true;
    this.onFocus.dispatch();
  };
}
